import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

// Utils
import http from '../../../utils/services/http';
import preloadImages from '../../../utils/preloadImages';
import { isGuestSelector } from '../../currentUserSelector';
import { navigateToLogin, navigateToRootWorkspace } from '../../../reducers/navigationActions';

// Components
import PromoBonus50FailureContent from './modalContent/PromoBonus50ClaimFailureContent';
import PromoBonus50SuccessContent from './modalContent/PromoBonus50ClaimSuccessContent';
import FullScreenModal from '../../../components/modal/FullScreenModal';
import PromoClaimLoadingContent from './modalContent/PromoClaimLoadingContent';
import AnimateHeightOnChildChange from '../../../components/animations/AnimateHeightOnChildChange';

import './PromoBonus50Modal.scss';

type PromoBonus50ModalProps = {
    params: {
        userId: string;
    };
};

const MODAL_STATES = {
    LOADING: 'loading',
    SUCCESS: 'success',
    FAILURE: 'failure',
};

const getModalContentCompnent = (modalState: string) => {
    switch (modalState) {
        case MODAL_STATES.LOADING:
            return PromoClaimLoadingContent;
        case MODAL_STATES.SUCCESS:
            return PromoBonus50SuccessContent;
        case MODAL_STATES.FAILURE:
        default:
            return PromoBonus50FailureContent;
    }
};

const PromoBonus50ClaimModal: React.FC<PromoBonus50ModalProps> = ({ params }) => {
    const { userId } = params;
    const dispatch = useDispatch();
    const isGuest = useSelector(isGuestSelector);

    const [modalState, setModalState] = useState(MODAL_STATES.LOADING);

    useEffect(() => {
        preloadImages([
            require('./modalContent/promo-claim-success.png'),
            require('./modalContent/promo-claim-failure.png'),
        ]);

        const claimBonusCards = async () => {
            try {
                const response = await http({
                    method: 'post',
                    url: 'promos/bonus50/claim',
                    data: {
                        userId,
                    },
                });

                if (response.data.success) {
                    setModalState(MODAL_STATES.SUCCESS);
                } else {
                    setModalState(MODAL_STATES.FAILURE);
                }
            } catch (error) {
                setModalState(MODAL_STATES.FAILURE);
            }
        };

        claimBonusCards();
    }, []);

    const handleActionButton = () => (isGuest ? dispatch(navigateToLogin()) : dispatch(navigateToRootWorkspace()));

    const ModalContent = getModalContentCompnent(modalState);

    return (
        <FullScreenModal className={classNames('PromoBonus50Modal mo-padding', { overlay: !isGuest })} autoWidth>
            <AnimateHeightOnChildChange transitionName="slide-left">
                <ModalContent action={handleActionButton} />
            </AnimateHeightOnChildChange>
        </FullScreenModal>
    );
};

export default PromoBonus50ClaimModal;
